export { MergeCompare } from "./merge-compare";